<template>
  <Modal
    cancelText="cancel"
    :handleMainAction="handleMainAction"
    headerText="Send Users Email"
    mainActionText="yes"
    :showClose="true"
    :visible="visible"
    @updateVisibility="handleClose"
  >
    <UserSecurityStatusList
      :class="$style.userList"
      :selectedUsers="selectedUsers"
    />
    <p data-test-id="confirmationMessage">
      {{ confirmationMessage }}
    </p>
  </Modal>
</template>

<script>
import BulkResendEmailMixin from 'client/systemusers/BulkResendEmail/BulkResendEmailMixin';
import Modal from 'client/components/Modal/Modal.vue';
import UserSecurityStatusList from 'client/systemusers/BulkResendEmail/UserSecurityStatusList.vue';
import pluralize from 'pluralize';

export default {
  name: 'BulkResendPasswordResetEmailModal',

  components: {
    Modal,
    UserSecurityStatusList,
  },

  mixins: [BulkResendEmailMixin],

  computed: {
    confirmationMessage() {
      return `Emails will only be sent to users who have an Active user state. 
      Are you sure you would like to send 
      ${pluralize('email', this.selectedUsers.length)} to the selected 
      ${pluralize('user', this.selectedUsers.length)}?`;
    },
  },
};
</script>

<style module>
.userList {
  margin-bottom: 25px;
}
</style>
